import { render, staticRenderFns } from "./collectsixth.vue?vue&type=template&id=002a8da3&scoped=true"
import script from "./collectsixth.vue?vue&type=script&lang=js"
export * from "./collectsixth.vue?vue&type=script&lang=js"
import style0 from "./collectsixth.vue?vue&type=style&index=0&id=002a8da3&prod&lang=less&scoped=true"
import style1 from "./collectsixth.vue?vue&type=style&index=1&id=002a8da3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002a8da3",
  null
  
)

export default component.exports